import { Skeleton } from '@/common/components/ui/skeleton';
import { CHART_HEIGHT_PX } from '@/features/telemetry/config';

export interface DeviceGridSkeletonProps {
  count?: number;
}

/**
 * Placeholder mirroring the real device grid — used while the series query is loading
 * with no `keepPreviousData` to fall back on yet (first load only).
 */
export function DeviceGridSkeleton({ count = 4 }: DeviceGridSkeletonProps) {
  return (
    <div data-testid="device-grid-skeleton" className="grid grid-cols-1 gap-5 md:grid-cols-2">
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className="flex flex-col gap-3 rounded-2xl border border-border bg-card p-5"
        >
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-5 w-16 rounded-full" />
          </div>
          <Skeleton className="rounded-lg" style={{ height: CHART_HEIGHT_PX }} />
          <div className="space-y-2 pt-1">
            <Skeleton className="h-5 w-full rounded-full" />
            <Skeleton className="h-5 w-full rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );
}
